import { IIngestionSourceData } from './types';

import automatedCsvSource from './automated-csv';
import lightspeedSource from './lightspeed';
import manualSource from './manual';
import manualCsvSource from './manual-csv';
import rentTheRunwaySource from './rent-the-runway';
import shopifyIngestionSource from './shopify';
import squareIngestionSource from './square';

export const SHOPIFY_SOURCE = "Shopify";
export const SHOPIFY_PUBLIC_SOURCE = "ShopifyPublic";
export const LIGHTSPEED_SOURCE = "Lightspeed";
export const MR_GENERIC_SOURCE = "MR_GENERIC";
export const AUTOMATED_CSV_SOURCE = "AutomatedCsv";
export const SQUARE_SOURCE = "Square";
export const RENT_THE_RUNWAY_SOURCE = "RTR";
export const MANUAL_SOURCE = "Manual";

export type IngestionSource =
  | "Shopify"
  | "ShopifyPublic"
  | "Lightspeed"
  | "MR_GENERIC"
  | "AutomatedCsv"
  | "Square"
  | "RTR"
  | "Manual";

export const INGESTION_SOURCE_DATA_MAP: Record<IngestionSource, IIngestionSourceData> = {
  [SHOPIFY_SOURCE]: shopifyIngestionSource,
  [SHOPIFY_PUBLIC_SOURCE]: shopifyIngestionSource,
  [LIGHTSPEED_SOURCE]: lightspeedSource,
  [SQUARE_SOURCE]: squareIngestionSource,
  [AUTOMATED_CSV_SOURCE]: automatedCsvSource,
  [MR_GENERIC_SOURCE]: manualCsvSource,
  [RENT_THE_RUNWAY_SOURCE]: rentTheRunwaySource,
  [MANUAL_SOURCE]: manualSource,
};
